import { cdn } from "@/helpers/api";

const getUniqueVenueKey = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = Math.floor(now.getMinutes() / 10) * 10; // Round down to nearest 10 minutes
  const roundedMinutes = String(minutes).padStart(2, "0");

  return `${year}${month}${day}${hours}${roundedMinutes}`;
};

export const getVenueSvg = async (id: string) => {
  try {
    const res = await cdn.get(`/venues/${id}.svg?key=${getUniqueVenueKey()}`);
    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
